import { Component, OnInit, ViewChild, Inject, OnDestroy } from '@angular/core';
import { TransactionService } from '../transaction.service';
import { MatPaginator, MatTableDataSource, MatDialogRef, MAT_DIALOG_DATA, MatInput } from '@angular/material';

@Component({
  selector: 'app-transaction-history',
  templateUrl: './transaction-history.component.html',
  styleUrls: ['./transaction-history.component.scss']
})
export class TransactionHistoryComponent implements OnInit, OnDestroy {

  filterValue = '';
  startDate: Date;
  endDate: Date;
  fetchedTime: Date;
  searchContent;
  country;
  branch;
  siteId;
  transactions: any[];
  transactionsOg: any[];
  transactionsDataSource = new MatTableDataSource<any>(this.transactions);
  transactionColumns = ['createdByName', 'time', 'details'];
  newTransactions: any[];
  newTransactionsTimer: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public dialogRef: MatDialogRef<TransactionHistoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private transactionService: TransactionService
  ) { }

  ngOnInit() {
    this.getTransactions();
  }

  ngOnDestroy() {
    clearInterval(this.newTransactionsTimer);
  }

  closeClicked() {
    this.dialogRef.close({result: 'closed'});
  }

  startDateChanged( t: any ): void {
    this.startDate = t.value;
    this.applyTransFilter();
  }

  endDateChanged( t: any ): void {
    this.endDate = t.value;
    this.applyTransFilter();
  }

  getTransactions() {
    this.country = localStorage.getItem('country');
    this.branch = localStorage.getItem('branchCode');
    this.siteId = localStorage.getItem('siteId');
    if (this.country === 'ALL' || this.branch === 'ALL') {
      this.getAllTransactions();
    } else if (this.siteId !== null) {
      this.getSiteTransactions(this.siteId);
    } else if (this.branch !== null) {
      this.getBranchTransactions(this.branch);
    } else if (this.country !== null) {
      this.getCountryTransactions(this.country);
    } else {
      this.getAllTransactions();
    }
  }

  getAllTransactions() {
    this.transactionService.getAllTransactions()
    .subscribe((data) => {
      this.transactions = data;
      this.transactionsOg = data;
      if (this.transactionsOg.length > 0) {
        this.fetchedTime = this.transactionsOg[0].createdTime;
      }
      this.transactionsDataSource = new MatTableDataSource<any>(this.transactions);
      this.transactionsDataSource.paginator = this.paginator;
      // this.newTransactionsTimer = setInterval(() => {
      //   this.getNewAllTransactions(this.fetchedTime);
      // }, 1000 * 3);
    });
  }

  getCountryTransactions(country: any) {
    this.transactionService.getCountryTransactions(country)
    .subscribe((data) => {
      this.transactions = data;
      this.transactionsOg = data;
      if (this.transactionsOg.length > 0) {
        this.fetchedTime = this.transactionsOg[0].createdTime;
      }
      this.transactionsDataSource = new MatTableDataSource<any>(this.transactions);
      this.transactionsDataSource.paginator = this.paginator;
      // this.newTransactionsTimer = setInterval(() => {
      //   this.getNewCountryTransactions(country, this.fetchedTime);
      // }, 1000 * 3);
    });
  }

  getBranchTransactions(branchCode: any) {
    this.transactionService.getBranchTransactions(branchCode)
    .subscribe((data) => {
      this.transactions = data;
      this.transactionsOg = data;
      if (this.transactionsOg.length > 0) {
        this.fetchedTime = this.transactionsOg[0].createdTime;
      }
      this.transactionsDataSource = new MatTableDataSource<any>(this.transactions);
      this.transactionsDataSource.paginator = this.paginator;
      // this.newTransactionsTimer = setInterval(() => {
      //   this.getNewBranchTransactions(branchCode, this.fetchedTime);
      // }, 1000 * 3);
    });
  }

  getSiteTransactions(siteId: any) {
    this.transactionService.getSiteTransactions(siteId)
    .subscribe((data) => {
      this.transactions = data;
      this.transactionsOg = data;
      if (this.transactionsOg.length > 0) {
        this.fetchedTime = this.transactionsOg[0].createdTime;
      }
      this.transactionsDataSource = new MatTableDataSource<any>(this.transactions);
      this.transactionsDataSource.paginator = this.paginator;
      // this.newTransactionsTimer = setInterval(() => {
      //   this.getNewSiteTransactions(siteId, this.fetchedTime);
      // }, 1000 * 3);
    });
  }

  getNewAllTransactions(fetchedTime) {
    this.transactionService.getNewAllTransactions(fetchedTime)
      .subscribe((data) => {
        this.newTransactions = [];
        this.newTransactions = data;
    });
  }

  getNewCountryTransactions(country, fetchedTime) {
    this.transactionService.getNewCountryTransactions(country, fetchedTime)
      .subscribe((data) => {
        this.newTransactions = [];
        this.newTransactions = data;
    });
  }

  getNewBranchTransactions(branchCode, fetchedTime) {
    this.transactionService.getNewBranchTransactions(branchCode, fetchedTime)
      .subscribe((data) => {
        this.newTransactions = [];
        this.newTransactions = data;
    });
  }

  getNewSiteTransactions(siteId, fetchedTime) {
    this.transactionService.getNewSiteTransactions(siteId, fetchedTime)
      .subscribe((data) => {
        this.newTransactions = [];
        this.newTransactions = data;
    });
  }

  filterChanged(filterValue: string) {
    this.filterValue = filterValue;
    this.applyTransFilter();
  }

  applyTransFilter() {
    this.transactions = this.transactionsOg;
    if (this.startDate === undefined && this.endDate === undefined) {
      this.transactions = Object.assign([], this.transactions).filter(
        item => item.createdByName.toLowerCase().indexOf(this.filterValue.toLowerCase()) > -1 ||
                item.details.toLowerCase().indexOf(this.filterValue.toLowerCase()) > -1
      );
    } else if (this.startDate === undefined) {
      this.transactions = Object.assign([], this.transactions).filter(
        item => (item.createdByName.toLowerCase().indexOf(this.filterValue.toLowerCase()) > -1 ||
                item.details.toLowerCase().indexOf(this.filterValue.toLowerCase()) > -1) &&
                Date.parse(item.createdTime) <= new Date(this.endDate).getTime() + 1000 * 60 * 60 * 24
      );
    } else if (this.endDate === undefined) {
      this.transactions = Object.assign([], this.transactions).filter(
        item => (item.createdByName.toLowerCase().indexOf(this.filterValue.toLowerCase()) > -1 ||
                item.details.toLowerCase().indexOf(this.filterValue.toLowerCase()) > -1) &&
                Date.parse(item.createdTime) >= new Date(this.startDate).getTime()
      );
    } else {
      this.transactions = Object.assign([], this.transactions).filter(
        item => (item.createdByName.toLowerCase().indexOf(this.filterValue.toLowerCase()) > -1 ||
                item.details.toLowerCase().indexOf(this.filterValue.toLowerCase()) > -1) &&
                Date.parse(item.createdTime) >= new Date(this.startDate).getTime() &&
                Date.parse(item.createdTime) <= new Date(this.endDate).getTime() + 1000 * 60 * 60 * 24
      );
    }
    this.transactionsDataSource = new MatTableDataSource<any>(this.transactions);
    this.transactionsDataSource.paginator = this.paginator;
  }

}
